export default __webpack_public_path__ + "static/media/1874-slide17-24-v5L.79426c42.mp4";